export const FACILITATOR_DASHBOARD = '/facilitatorDashboard';
export const FACILITATOR_TOURNAMENT = `${FACILITATOR_DASHBOARD}/tournament`;
export const FACILITATOR_TOURNAMENT_CLASS = `${FACILITATOR_TOURNAMENT}/class`;
